import {
  BACKOFFICE_PERMISSIONS,
  PERMISSIONS,
} from '../../../utils/permissions';
import { Audience, DocPage, Guide } from './types';

/**
 * Whether a user with these permissions is the audience of a page. It goes by permissions, like every page of
 * the viewer, and they follow the Auth0 roles: a Labeler holds list:ownLabelTask, a Reader adds read:labelPass,
 * a Corrector fix:labelPass, a Data Manager every permission. The documentation itself sits behind RequireRole,
 * so an account without a role never reaches it.
 */
export function isAudience(
  audience: Audience,
  has: (permission: string) => boolean
): boolean {
  switch (audience) {
    case 'everyone':
      return true;
    case 'labelling':
      return has(PERMISSIONS.LIST_OWN_LABEL_TASK);
    case 'reading':
      return has(PERMISSIONS.READ_LABEL_PASS);
    case 'correction':
      return has(PERMISSIONS.FIX_LABEL_PASS);
    case 'admin':
      return BACKOFFICE_PERMISSIONS.some(has);
  }
}

/** The pages this user may read, in the order they are given. */
export function visiblePages(
  pages: DocPage[],
  has: (permission: string) => boolean
): DocPage[] {
  return pages.filter(page => isAudience(page.audience, has));
}

/** The guides this user has pages in: the user guide for every role, the data managers' for them. */
export function visibleGuides(pages: DocPage[]): Guide[] {
  return (['user', 'admin'] as Guide[]).filter(guide =>
    pages.some(page => page.guide === guide)
  );
}
